const GLOABL_CONSTANS = Object.freeze({
    USER_TOKEN:'token',
});

export {
    GLOABL_CONSTANS
}